var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentItem',{attrs:{"name":_vm.name}},[_c('Dropdown',{style:('width:200px;'),attrs:{"items":_vm.calendar,"selected":_vm.firstday},on:{"change":_vm.selectDay}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }